import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import debug from "debug";
import _ from "lodash";
import { basename } from "path";
import * as VueGoogleMaps from "vue2-google-maps";
import SocialSharing from "vue-social-sharing";
import { library } from "@fortawesome/fontawesome-svg-core";
import vSelect from 'vue-select';
import VueGtm from '@gtm-support/vue2-gtm';

// import {
//   faCheckCircle
// } from "@fortawesome/free-regular-svg-icons";
import {
  faChevronDown,
  faChevronUp,
  faSearch,
  faMapMarkerAlt,
  faQuestionCircle,
  faNewspaper,
  faGlobe,
  faWifi,
  faBalanceScale,
  faPhoneAlt,
  faServer,
  faCheckCircle,
  faClock,
  faSms,
  faEnvelope,
  faAngleLeft,
  faCaretRight,
  faUsers,
  faShoppingCart,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookSquare,
  faLinkedin,
  faWhatsapp,
  faWhatsappSquare,
  faTwitter,
  faTelegram,
  faReddit,
  faLine,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";


import App from "./App.vue";
import router from "./router";
import store from "./store";

const DOMAINS = Object.keys(JSON.parse(process.env.VUE_APP_BRAND_ID_MAP));

function getDomainAndSubdomain(url) {
  let match = DOMAINS.find(d => url.includes(d)) || null;

  let subdomain = null;
  if (match) {
      let index = url.indexOf(match);
      subdomain = index > 0 ? url.substring(0, index - 1) : null;
  }

  return {domain: match, subdomain};
}

let {domain, subdomain} = getDomainAndSubdomain(window.location.host);

function getBrandId(domain) {
  const map = JSON.parse(process.env.VUE_APP_BRAND_ID_MAP);
  let brandId = map[domain];
  if (brandId === undefined) {
    brandId = "";
  }
  return brandId;
}

if (subdomain) {
  const brandId = getBrandId(domain);
  const zonecode = subdomain + brandId;
  const protocol = window.location.protocol;
  const suffix = /^\/a\/[a-zA-Z0-9]+$/.test(window.location.pathname) && window.location.pathname || "";
  if (["cybersmart.co.za", "lightspeed.co.za"].includes(domain)) {
    domain = "www." + domain;
  } else if (["ftta.co.za"].includes(domain)) {
    domain = "buildings." + domain;
  }
  window.location = `${protocol}//${domain}/location/${zonecode}${suffix}`;
}
Vue.config.productionTip = false;

library.add(
  faShoppingCart,
  faChevronDown,
  faChevronUp,
  faCaretRight,
  faSearch,
  faMapMarkerAlt,
  faQuestionCircle,
  faNewspaper,
  faGlobe,
  faWifi,
  faBalanceScale,
  faPhoneAlt,
  faServer,
  faCheckCircle,
  faClock,
  faSms,
  faEnvelope,
  faFacebookSquare,
  faLinkedin,
  faWhatsapp,
  faWhatsappSquare,
  faTwitter,
  faTelegram,
  faReddit,
  faLine,
  faAngleLeft,
  faUsers,
  faLock,
);

Vue.component('v-select', vSelect);
Vue.use(require("vue-moment"));
Vue.component("fa-icon", FontAwesomeIcon);
Vue.use(SocialSharing);
Vue.use(VueAxios, axios);
Vue.use({
  install(vue) {
    vue.log = debug("cybersmart-frontend:vue");

    Vue.prototype.$log = function vueLog(...args) {
      const path = [];
      let me = this;

      do {
        path.push(
          me.$options.name ||
            me.$options._componentTag ||
            (me.$options.__file &&
              _.upperFirst(
                _.camelCase(
                  basename(me.$options.__file.replace(/^[a-zA-Z]:/, ""))
                ).replace(/\\/g, "/"),
                ".vue"
              ))
        );
        me = me.$parent;
      } while (me.$parent);

      debug(`cybersmart-frontend:vue:${path.reverse().join(":")}`)(...args);
    };
  },
});

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAPS_API_KEY,
    libraries: "places",
  },
});

Vue.directive('click-outside',{
  bind: function (el, binding, vnode) {
      el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
      }
      el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
      }
      el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
              // call method provided in attribute value
              vnode.context[binding.expression](event);
          }
      };
      document.addEventListener('touchstart', el.eventClearDrag);
      document.addEventListener('touchmove', el.eventSetDrag);
      document.addEventListener('click', el.eventOnClick);
      document.addEventListener('touchend', el.eventOnClick);
  }, unbind: function (el) {
      document.removeEventListener('touchstart', el.eventClearDrag);
      document.removeEventListener('touchmove', el.eventSetDrag);
      document.removeEventListener('click', el.eventOnClick);
      document.removeEventListener('touchend', el.eventOnClick);
      el.removeAttribute('data-dragging');
  },
});


Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTAG_KEYS.split(","),
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: router,
});
new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount("#app");

